import React from "react";
import { getOrders } from "./order-section.service";
import moment from "moment";
import { Link } from "react-router-dom";

export default function OrderSection() {
  const [orders, setOrders] = React.useState([]);
  const [loader, setLoader] = React.useState(true);

  React.useEffect(() => {
    getOrders().then((res) => {
      setOrders(res.data.results);
      setLoader(false);
    });
  }, []);

  if (loader) {
    return <div>Loading...</div>;
  }

  if (orders.length === 0) {
    return (
      <div className="text-center">
        <h1>No orders found</h1>
      </div>
    );
  }
  return (
    <section className="ec-page-content section-space-p">
      <div className="container">
        <div className="row">
          <div className="ec-cart-leftside col-lg-12 col-md-12 ">
            <div className="ec-cart-content">
              <div className="ec-cart-inner">
                <div className="row">
                  <form action="#">
                    <div className="table-content cart-table-content">
                      <table>
                        <thead>
                          <tr>
                            <th className="product_thumb">Order Number</th>
                            <th className="product_thumb">Size In</th>
                            <th className="product_thumb">Submit Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orders.map((order: any) => (
                            <tr key={order.id}>
                              <td
                                data-label="Order Number"
                                className="ec-cart-pro-name"
                              >
                                <Link to={`/order/${order.id}`}>
                                  #{" "}
                                  {order.orderNumber
                                    .toString()
                                    .padStart(5, "0")}
                                </Link>
                              </td>
                              <td
                                data-label="Size In"
                                className="ec-cart-pro-price"
                              >
                                <span className="amount">{order.size}</span>
                              </td>
                              <td
                                data-label="Submit Date"
                                className="ec-cart-pro-qty"
                              >
                                <span>
                                  {moment(order.createdAt).format("DD/MM/YYYY")}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
